import get from 'lodash/get'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import PriceSection from './PriceSection'
import Shared from './Shared'
import Single from './Single'
import styles from './SingleOccupancyCard.module.scss'

Notification.propTypes = {
  product: PropTypes.object,
  isUpgraded: PropTypes.bool,
  isShared: PropTypes.bool,
  setIsCollapsed: PropTypes.func,
  numberOfProducts: PropTypes.number,
  currency: PropTypes.string,
  updateShared: PropTypes.func,
  occupancy: PropTypes.object,
  maxOccupancy: PropTypes.number,
  isShareable: PropTypes.bool,
}

export default function Notification({
  product,
  isUpgraded,
  isShared,
  setIsCollapsed,
  numberOfProducts,
  currency,
  updateShared,
  occupancy,
  maxOccupancy,
  isShareable,
}) {
  const roomTitle = get(product, 'room.roomCategory.title', '')
  const numberOfGuests = get(product, 'room.totalGuests')
  const isApplySingle = !isShareable && maxOccupancy > 1

  const sharedHandler = (wantsShared) => {
    setIsCollapsed(true)
    updateShared(product, false, wantsShared)
  }

  useEffect(() => {
    updateShared(product, true, !isShared)
  }, [])

  const getHeader = () => {
    if(isUpgraded) {
      return (
        <FormattedMessage
          id='switch_back_to_shared'
          defaultMessage='Would you like to switch back to SHARED OCCUPANCY?'
        />
      )
    }
    if(isApplySingle) {
      return (
        <FormattedMessage
          id='single_occupancy_was_applied'
          defaultMessage='Single occupancy price was applied'
        />
      )
    }
    if(isShared) {
      return (
        <FormattedMessage
          id='upgrade_to_single_occupancy'
          defaultMessage='Would you like to upgrade to SINGLE OCCUPANCY?'
        />
      )
    }
    return (
      <FormattedMessage
        id='switch_back_to_shared'
        defaultMessage='Would you like to switch back to SHARED OCCUPANCY?'
      />
    )
  }

  return (
    <div className={styles.notification}>
      <div className={styles.header}>
        {isApplySingle && (
          <button
            type='button'
            className={styles.closeBtn}
            onClick={() => setIsCollapsed(true)}
          >
            <i className='font-icons close-icon' />
          </button>
        )}
        {numberOfProducts > 1 && (
          <p className={styles.roomTitle}>{roomTitle}</p>
        )}
        <p className={styles.title}>{getHeader()}</p>
      </div>
      {isShared ? (
        <Shared
          roomTitle={roomTitle}
          numberOfProducts={numberOfProducts}
          setIsCollapsed={setIsCollapsed}
          numberOfGuests={numberOfGuests}
          sharedHandler={sharedHandler}
          priceSection={
            <PriceSection
              product={product}
              currency={currency}
              occupancy={occupancy}
              isApplySingle={isApplySingle}
              isUpgraded={isUpgraded}
            />
          }
        />
      ) : (
        <Single
          sharedHandler={sharedHandler}
          setIsCollapsed={setIsCollapsed}
          isApplySingle={isApplySingle}
          priceSection={
            <PriceSection
              product={product}
              currency={currency}
              occupancy={occupancy}
              isApplySingle={isApplySingle}
              isUpgraded={isUpgraded}
            />
          }
        />
      )}
    </div>
  )
}
